import React from "react"
import { css } from "@jsUtils"
import { CTA, Headline, GridLines } from "@shared"
import { CONSTANTS } from "@data"
import { PageSection } from "../PageSection"
import Styles from "./jobList.module.scss"

const { THEMES, JOBS } = CONSTANTS
const JobList = () => {
  const jobs = JOBS
  const [ready, setReady] = React.useState(false)
  return (
    <PageSection
      className={css(Styles.section, ready && Styles.ready)}
      theme={THEMES.TIN}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      <GridLines />
      <div className={Styles.content}>
        <Headline size={1} className={Styles.headline}>
          Open Positions
        </Headline>
        {jobs.map(job => (
          <div>
            <CTA
              ascope="CTAS"
              adata="MISC.JOINUS"
              ready={ready}
              className={Styles.cta2}
              color="fluro"
              to={`/${job.pathname}`}
              target="_blank"
              rel="noopener noreferrer"
              anchor
            >
              {job.buttonName}
            </CTA>
          </div>
        ))}
      </div>
    </PageSection>
  )
}
export default JobList
